import { ArrowUturnLeftIcon } from "@heroicons/react/20/solid";
import { Button, ButtonState } from "src/components/Button";
import { useTranslation } from "src/translations";

export function HistoryUndoButton({
  onClick,
  disabled,
}: {
  onClick: () => void;
  disabled: boolean;
}) {
  const { t } = useTranslation();
  return (
    <Button
      title={t("toolbox.undo")}
      Icon={ArrowUturnLeftIcon}
      state={!disabled ? ButtonState.NONE : ButtonState.DISABLED}
      onClick={onClick}
    />
  );
}
